import type { ReactNode } from 'react'

export function Spinner({ label = 'Loading' }: { label?: string }) {
  return <div className="loading" role="status"><span className="spinner" aria-hidden="true" /> <span>{label}…</span></div>
}

export function EmptyState({ title, children, action }: { title: string; children: ReactNode; action?: ReactNode }) {
  return <div className="empty-state"><div className="empty-icon" aria-hidden="true">⌁</div><h3>{title}</h3><p>{children}</p>{action}</div>
}

export function StatusBadge({ value }: { value: string }) {
  return <span className={`badge badge-${value.replaceAll('_', '-')}`}>{value.replaceAll('_', ' ')}</span>
}

export function Alert({ tone = 'info', children }: { tone?: 'info' | 'success' | 'error' | 'warning'; children: ReactNode }) {
  return <div className={`alert alert-${tone}`} role={tone === 'error' ? 'alert' : 'status'}>{children}</div>
}

export function FieldError({ message }: { message?: string }) {
  return message ? <span className="field-error">{message}</span> : null
}

export function PageHeader({ eyebrow, title, description, actions }: { eyebrow?: string; title: string; description?: string; actions?: ReactNode }) {
  return <header className="page-header"><div>{eyebrow && <p className="eyebrow">{eyebrow}</p>}<h1>{title}</h1>{description && <p>{description}</p>}</div>{actions && <div className="page-actions">{actions}</div>}</header>
}

export function ConfirmButton({ children, prompt, className = 'button button-danger', onConfirm, disabled }: { children: ReactNode; prompt: string; className?: string; onConfirm: () => void | Promise<void>; disabled?: boolean }) {
  return <button className={className} disabled={disabled} onClick={() => { if (window.confirm(prompt)) void onConfirm() }}>{children}</button>
}

